const removeChooseStoreLink = () => {
  const chooseStoreLinks = document.querySelectorAll('.cmp-store__text--choose-store');

  chooseStoreLinks.forEach((chooseStoreLink) => {
    chooseStoreLink.remove();
  });
};

const renderStoreLink = (storeDetails) => {
  const storeLinks = document.querySelectorAll('.cmp-store');
  const linkTexts = document.querySelectorAll('.cmp-store__text--go-to-store');

  storeLinks.forEach((storeLink) => {
    storeLink.href = storeDetails.storeLink;
  });

  linkTexts.forEach((linkText) => {
    linkText.ariaLabel = `Go to my store ${storeDetails.name}`;
    linkText.classList.remove('util-display-none');
  });
};

const renderStoreAddress = (storeDetails) => {
  const storeAddresses = document.querySelectorAll('.cmp-store-address');

  storeAddresses.forEach((storeAddress) => {
    const storeNameValue = storeAddress.querySelector('.cmp-store-address__store-name');
    const storePhoneNumber = storeAddress.querySelector('.cmp-store-address__store-phone-number');
    const phoneNumber = storeDetails.phoneVisual ? storeDetails.phoneVisual : storeDetails.phone;

    storePhoneNumber.innerHTML = phoneNumber;
    storeNameValue.innerHTML = storeDetails.name;
    storeNameValue.ariaHidden = 'false';

    storeAddress.classList.remove('util-display-none');
  });
};

const renderStoreIcon = () => {
  const storeLogos = document.querySelectorAll('.cmp-header__store-link');

  storeLogos.forEach((storeLogo) => {
    storeLogo.ariaHidden = 'false';
    storeLogo.classList.remove('util-display-none');
  });
};

const renderStoreDetails = (storeDetails) => {
  if (storeDetails.hasStoreDetails) {
    removeChooseStoreLink();
    renderStoreIcon();
    renderStoreLink(storeDetails);
    renderStoreAddress(storeDetails);
  }
};

export {
  renderStoreDetails,
};
